import req from './http.js'
import config from "../config";
import url from "@/app/url";

const newApiBaseUrl = !config.app  ? config.newApi.dev : config.newApi.pro

//banner接口
export const banner = params => req('post', '/v1/live/banner', params)
//收集玉雕师信息
export const collectCelebrity = params => req('post', 'https://dev.jaadee.net/api/usr/celebrity/collect', params)
//发送验证码
export const sendMsg = params => req('post', 'https://dev.jaadee.net/api/usr/index.php/v2/login/sendMsg', params)
//根据姓名查询是否是玉雕师
export const checkOur = params => req('get', '/v1/master/checkOur', params)
//玉雕师入驻申请数据保存
export const settledData = params => req('post', '/v1/master/settledData', params)
//图片上传
export const inputImgs = params => req('post', (config.app ? 'https://sup.jaadee.net' : 'https://suptest.jaadee.net') + '/v1/upload/files', params)
// 获取微信配置
export const getWxConfig = params => req('get', (config.app ? 'https://bgate.jaadee.net/' : 'https://jtest.jaadee.net/') + 'wechat/api/v3/weChatAccountShare/jaadeeVueAppShare', params)
///提交意见反馈
export  const submitSetFeedBack = params => req('post', newApiBaseUrl + 'Member/feedback.html', params)
